import { ThemeProvider } from '@material-ui/styles';
import { useStoreRehydrated } from 'easy-peasy';
import { ReactElement } from 'react';

import useGlobalError from '~/hooks/error/useGlobalError';
import PanicRequestsProvider from '~/services/socket/PanicRequestsProvider';
import { useStoreActions } from '~/store/hooks';
import BugsnagClient from '../utils/error/bugsnag';

import CrisisRequestsProvider from '~/services/socket/CrisisRequestsProvider';
import { SignalRTokenProvider } from '~/services/socket/SignalRTokenProvider';
import Routes from './Routes';
import Loader from './components/common/Loader';
import ReleaseAlert from './pages/Notifications/components/ReleaseAlert';
import SignalRCrisisAlert from './pages/Notifications/components/SignalRCrisis/SignalRCrisis';
import SignalRSOS from './pages/Notifications/components/SignalRSOS';
import SystemAlert from './pages/Notifications/components/SystemAlerts/components/SystemAlert';
import muiTheme from './themes/muiTheme';

import './assets/styles/app.scss';

BugsnagClient.startSession();

const App = (): ReactElement => {
  const isRehydrated = useStoreRehydrated();
  useGlobalError();
  const onCheckAuthorization = useStoreActions(actions => actions.user.onCheckAuthorization);
  onCheckAuthorization();

  return (
    <SignalRTokenProvider>
      <PanicRequestsProvider>
        <CrisisRequestsProvider>
          <ThemeProvider theme={muiTheme}>
            <>
              {isRehydrated ? <Routes /> : <Loader />}
              <SignalRSOS.SignalRSOSAlert />
              <SignalRCrisisAlert />
              <ReleaseAlert />
              <SystemAlert />
            </>
          </ThemeProvider>
        </CrisisRequestsProvider>
      </PanicRequestsProvider>
    </SignalRTokenProvider>
  );
};
export default App;
